// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import "./plugins/vuetify";
import "./plugins/moment";
import "./plugins/vuedatetime";
import "./plugins/sentry";
import "./plugins/echarts";
import "./plugins/uploadButton";
import "./plugins/preetyBytes";
import "font-awesome/css/font-awesome.css";
import "./theme/default.styl";
import VeeValidate from "vee-validate";
import Truncate from "lodash.truncate";
import i18n from "./common/lang.serivce";
import validationMessages from "vee-validate/dist/locale/pl";
import ApiService from "./common/api.service";
import ConfirmationDialog from "@/components/dialog/ConfirmationDialog.vue";
import DeleteConfirmationDialog from "@/components/dialog/DeleteConfirmationDialog.vue";
import SimpleCard from "@/components/SimpleCard.vue";
import _ from "lodash";
import Nl2br from "vue-nl2br";
import MiniStatistics from "@/components/dashboard/MiniStatistics";
import ActionTooltip from "@/components/ActionTooltip";
import PageHeader from "@/components/PageHeader";
import "./registerServiceWorker";
import utils from "./util";

import AuDatepicker from "@/components/AuDatepicker.vue";
import AuDateTimePicker from "@/components/AuDateTimePicker.vue";
import AuVehicle from "@/components/AuVehicle.vue";

Vue.config.productionTip = false;

// Global filters
Vue.filter("truncate", Truncate);
Vue.filter("booleanText", function(value) {
  return value ? i18n.t("yes") : i18n.t("no");
});
Vue.filter("percent", utils.percents);
Vue.filter("lackOfData", function(value) {
  return _.isEmpty(value) ? i18n.t("lack") : value;
});
Vue.filter("detailedDuration", function(value) {
  let days = 0,
    hours = 0,
    minutes = 0;

  hours = Math.floor(value / 60);
  minutes = value % 60;
  days = Math.floor(hours / 24);
  hours = hours % 24;

  return (
    (days === 1
      ? days + " " + i18n.t("day")
      : days > 1
      ? days + " " + i18n.t("days")
      : " ") +
    " " +
    (hours === 1
      ? hours + " " + i18n.t("hour")
      : hours > 1
      ? hours + " " + i18n.t("hours")
      : " ") +
    " " +
    (minutes > 0 ? minutes + " " + i18n.t("minutes") : " ")
  ).trim();
});
Vue.filter("unit", function(value, unitName) {
  return value ? value + " " + unitName : "";
});
Vue.filter("infinity", function(value) {
  return value === null || typeof value === "undefined" ? "∞" : value;
});

Vue.component("confirmation-dialog", ConfirmationDialog);
Vue.component("delete-dialog", DeleteConfirmationDialog);
Vue.component("simple-card", SimpleCard);
Vue.component("mini-statistics", MiniStatistics);
Vue.component("action-tooltip", ActionTooltip);
Vue.component("page-header", PageHeader);
Vue.component("nl2br", Nl2br);

Vue.component("au-datepicker", AuDatepicker);
Vue.component("au-date-time-picker", AuDateTimePicker);
Vue.component("au-vehicle", AuVehicle);

Vue.use(VeeValidate, {
  fieldsBagName: "formFields",
  i18nRootKey: "validations",
  i18n,
  dictionary: {
    pl: validationMessages
  }
});

// Bootstrap application components

ApiService.init();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
